import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectContextService } from '@services/project-context/project-context.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public username: string = '';
  public password: string = '';
  public errorMessageKey: string | null = null;
  public showPassword: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private projectContext: ProjectContextService
  ) {}

  ngOnInit(): void {
    const last = this.authService.consumeLastAuthError();
    if (last) {
      this.errorMessageKey = last;
    }
  }

  async login() {
    this.errorMessageKey = null;
    const result = await this.authService.loginDetailed(this.username, this.password);
    if (!result.ok) {
      this.errorMessageKey = result.messageKey;
      return;
    }

    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    const normalizedReturn = returnUrl && returnUrl.startsWith('/') ? returnUrl : '/home';

    // If project is not selected yet, ask for it before navigating to the rest of the app.
    if (!this.projectContext.getSelectedProjectIdSnapshot()) {
      this.router.navigate(['/select-project'], { queryParams: { returnUrl: normalizedReturn } });
      return;
    }

    this.router.navigateByUrl(normalizedReturn);
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
}
